import { graphql, useMutation } from 'react-relay';

const mutation = graphql`
  mutation PortfolioRetireMutation($uuid: ID!) {
    retirePortfolio(uuid: $uuid) {
      id
      uuid
    }
  }
`;

/**
 * Hook for retiring a portfolio.
 * Using `useMutation` hook as recommended by [Relay docs](https://relay.dev/docs/api-reference/use-mutation/)
 * as an improvement over calling `commitMutation` directly.
 * @returns {Function} A function to trigger the retire portfolio mutation
 */
function usePortfolioRetireMutation() {
  const [commit] = useMutation(mutation);

  const retirePortfolio = (uuid, onCompleted, onError) => {
    commit({
      variables: { uuid },
      onCompleted,
      onError,
    });
  };

  return retirePortfolio;
}

export default usePortfolioRetireMutation;
